import Hubspot from "@/assets/crm/hubspot.svg";
import { constants } from "@/constants";
import { Trans } from "react-i18next";

import { useCRMConnectionListStatus } from "@/hooks/api/list/crm/useCRMConnectionListStatus";
import Badge from "@/components/atoms/Badge";
import Tooltip from "@/components/atoms/Tooltip";

type Props = {
  listId: string;
};

const CRMBadges = ({ listId }: Props) => {
  const { data, isLoading } = useCRMConnectionListStatus({ id: listId });

  if (isLoading || !data) {
    return null;
  }

  return (
    (data.hubspot.connected || data.hubspot.error) && (
      <div className={"flex gap-3"}>
        <Badge
          leadingIcon={<img src={Hubspot} alt={"Hubspot"} className={"size-4"} />}
          color={"white"}
          className={"select-none"}
          size={"sm"}
          label={
            <>
              <Trans
                i18nKey={`crm.connections.status.${data.hubspot.error ? "failed" : "synced"}`}
                values={{ platform: "Hubspot" }}
                components={{ success: <span className={"text-success"} />, error: <span className={"text-error"} /> }}
              />
              {data.hubspot.error && (
                <Tooltip symbol={"info"} as={"div"}>
                  <div>
                    <Trans
                      i18nKey={"crm.connections.status.failedTooltip"}
                      values={{ mail: constants.supportMail }}
                      components={{
                        a: <a href={`mailto:${constants.supportMail}`} className={"text-link hover:underline"} />,
                      }}
                    />
                  </div>
                </Tooltip>
              )}
            </>
          }
        />
      </div>
    )
  );
};

export default CRMBadges;
